<template>
    <div class="w-layout-grid content-3-col-grid">
        <div class="side-content">
        </div>
        <div id="course-students-component" class="middle-content middle-content-initial-state">
            <div class="course-top">
                <div class="course-name-block">
                    <h2 class="section-title">
                        <template v-if="!keepModal">
                            {{trans('messages.course_creator_enrolled_students')}}
                        </template>
                        <template v-else>
                            <span>Keep</span>
                            <span class="ml-3" v-if="student">
                            Student: {{student.first_name}} {{student.last_name}}</span>
                        </template>
                    </h2>
                </div>
            </div>
            <div class="row mt-3" v-if="!keepModal">
                <template v-if="students.length > 0">
                    <div v-for="student in students" class="col-6">
                        <div class="row">
                            <div class='col-8'>
                                <div><strong>{{student.student.first_name}} {{student.student.last_name}}</strong></div>
                                <div>{{student.student.email}}</div>
                            </div>
                            <div class='col-4'>
                            <button @click="keepClick(student.user_id)" class="btn btn-primary mt-1">
                                <i class="fas fa-search"></i>
                                Keep
                            </button>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="col-12 text-center">
                        <h5>No {{trans('messages.course_creator_enrolled_students')}}</h5>
                    </div>
                </template>
            </div>
            <div v-else class="row">
                <div class="col-12 text-center">
                    <ckeditor :editor="editor" v-model="keep" :config="editorConfig"></ckeditor>
                </div>
            </div>
            <div class="mt-2">
                <button v-if="keepModal" type="button" class="btn btn-primary" @click="keepModal=false">
                    <i class="fas fa-chevron-left"></i>
                    Back to Students
                </button>
                <button type="button"v-if="keepModal"  @click="saveKeep()" class="btn btn-primary">Save</button>
            </div>
        </div>
        <div class="side-content right side-right-initial-state">
        </div>
    </div>
</template>
<script>
    import CustomEditor from "../../includes/ck-editor/ck-editor-custom";

    export default {
        name: "course-students",
        components: {
        },
        created() {
            const url = window.location.pathname;
            let id = parseInt(url.substring(url.lastIndexOf('/') + 1));
            if (id && Number.isInteger(id)) {
                this.form.id = id;
                this.getStudents();
            }
        },

        data: function() {
            return {
                keepStudent: 0,
                students : [],
                student: [],
                keepModal: false,
                keep: '',
                form: {
                    id: null,
                },
                editor: CustomEditor,
                editorConfig: {
                    mediaEmbed: {previewsInData: true},
                    link: {
                        addTargetToExternalLinks: true,
                        defaultProtocol: 'http://',
                    },
                },
            }
        },
        mounted(){

        },
        methods: {
            getStudents() {
                let $end = '/api/get-course-students/'+this.form.id;
                let self = this;
                axios.get($end).then(function (res) {
                    let response = res.data.data;
                    self.students = response;
                    $('#studentsModal').modal('show');
                }).catch(err => {
                    console.log(err);
                    this.$data.loader = false;
                });
            },
           keepClick: function(id) {

                let $end = '/api/get-course-student/'+this.form.id+'/'+id;
                let self = this;
                axios.get($end).then(function (response) {
                    response = response.data;
                    self.keep = response.keep;
                    self.keepModal = true;
                    self.keepStudent = response.user_id;
                    self.student = response.student;
                }).catch(err => {
                    console.log(err);
                    this.$data.loader = false;
                });
            },
            saveKeep: function() {
                let $end = '/api/save-keep';
                let self = this;
                axios.post($end, {course_id: this.form.id, student_id: this.keepStudent, keep: this.keep}).then(response  => {
                    $('#studentsModal').modal('hide');
                    self.keepModal = false;
                }).catch(err => {
                    this.$data.loader = false;
                });
            },
        },
    }
</script>
<style type="text/css">
    #course-students-component .ck-content {
        border: 1px solid grey !important;
    }
</style>
